import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Decyzje',
  type: 'object',
  properties: {
    value: {
      type: 'array',

      items: {
        type: 'object',
        properties: {
          type: {
            title: 'Rodzaj',
            type: 'string',
            fieldRequired: true
          },

          name: {
            title: 'Nazwa',
            type: 'string',
            fieldRequired: true
          },

          releaseDate: {
            title: 'Data wydania',
            type: 'string',
            format: 'date'
          },

          receiveDate: {
            title: 'Data odebrania',
            type: 'string',
            format: 'date'
          }
        }
      }
    }
  },
  allOf: [validationMessages]
};
